import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { cn } from '@marvelapp/ballpark-components';
export const Grid = observer(function Grid(props) {
    const { children, className } = props;
    return (_jsx("div", { className: cn('grid', 'gap-6', 'w-full', 'grid-cols-1', 'sm:grid-cols-2', 'md:grid-cols-3', 'lg:grid-cols-4', 'xl:grid-cols-5', '2xl:grid-cols-6', 'min-[1896px]:grid-cols-7', 'min-[2136px]:grid-cols-8', 'min-[2376px]:grid-cols-9', className), children: children }));
});
